import React from 'react';

const PrivacyTipIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 0 24 24"
    width="24px"
    focusable="false"
    aria-hidden="true"
    fill="currentColor"
    className="MuiSvgIcon-root"
    style={{ paddingLeft: '10px', marginRight: '16px', color: '#0000008a' }}
  >
    <g>
      <rect fill="none" height="24" width="24" />
      <path d="M12,1L3,5v6c0,5.55,3.84,10.74,9,12c5.16-1.26,9-6.45,9-12V5L12,1L12,1z M11,7h2v2h-2V7z M11,11h2v6h-2V11z" />
    </g>
  </svg>
);

export default PrivacyTipIcon;



// WEBPACK FOOTER //
// ./src/components/common/LimitV2/PrivacyTipIcon.js